export enum EConnectorType {
    TEAM
}